































































































































import Vue from 'vue'
import {
  IChronologyCommentFormData,
  IChronologyComment,
} from '@/types/data-objects/item-histories'
import { IAttachment } from '@/types/data-objects/attachments'

export default Vue.extend({
  name: 'ChronologyComment',

  props: {
    commentInfo: {
      type: Object as () => IChronologyComment,
      required: true,
    },
    visibilityNote: {
      type: String,
      default: '',
      required: false,
    },
    rolledOverComment: {
      type: Boolean,
      default: false,
    },
    // Function used when submit edited comment
    submitHandler: {
      type: Function,
      required: true,
      default: (): any => {},
    },
  },

  data() {
    return {
      isEditing: false,
      isFormLoading: false,
      originalFileList: [],
      formData: {
        content: '',
        fileList: [],
        listAtMentionIDs: [],
        listFileUploadIDs: [],
        listRemovedAttachmentIDs: [],
      } as IChronologyCommentFormData,
      showMoreOptions: false,
    }
  },

  computed: {
    attachmentsToDisplay(): any {
      return this.commentInfo.attachments.filter(
        item =>
          !item.hasOwnProperty('status') ||
          (item.hasOwnProperty('status') && item.status === 'success'),
      )
    },
    avatarSize(): number {
      if (this.$screen.isDesktop(this.$mq)) {
        return 40
      }
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return 24
      }
    },
    hasAttachmentsToDisplay(): boolean {
      return this.attachmentsToDisplay.length > 0
    },
  },

  watch: {
    commentInfo: {
      immediate: true,
      handler(value) {
        this.formData.content = value.description
        this.formData.fileList = value.attachments
        this.originalFileList = value.attachments
      },
    },
    rolledOverComment: {
      handler(value) {
        if (this.$screen.isTabletOrDesktop(this.$mq)) {
          this.showMoreOptions = value
        }
      },
    },
  },

  mounted() {
    // Add comment data to form for further editing
    this.resetFormDataLists()
  },

  methods: {
    initiateLinkedTask(id: Number) {
      // This vuex prop is being watched by the task/convo detail header
      this.$store.set('app/itemEventForLinkedTaskID', id)
    },
    enableCommentEdit() {
      this.isEditing = true
    },
    resetFormDataLists() {
      this.formData.listAtMentionIDs = []
      this.formData.listFileUploadIDs = []
      this.formData.listRemovedAttachmentIDs = []
      this.formData.fileList = this.commentInfo.attachments.filter(
        item =>
          !item.hasOwnProperty('status') ||
          (item.hasOwnProperty('status') && item.status === 'success'),
      )
    },

    disableEditMode() {
      this.isEditing = false
      this.formData.fileList = this.originalFileList
      this.resetFormDataLists()
    },

    /**
     * Insert mentions in attribute
     */
    insertMentions(matches: any) {
      this.formData.listAtMentionIDs = matches
    },

    /**
     * Insert file in FormData
     */
    addFileHandler(files: IAttachment[]) {
      files.forEach(file => {
        if (!this.formData.fileList.includes(file)) {
          this.formData.fileList.push(file)
        }
      })

      this.formData.listFileUploadIDs = this.formData.fileList
        .filter(item => item.status === 'ready')
        .map(item => item.id)
    },

    /**
     * Remove file from FormData
     */
    removeFileHandler(id: number) {
      const file = this.formData.fileList.find(item => item.id === id)

      this.formData.fileList = this.formData.fileList.filter(
        item => item.id !== id,
      )

      if (file.status && file.status === 'ready') {
        this.formData.listFileUploadIDs = this.formData.listFileUploadIDs.filter(
          item => item !== id,
        )
      } else {
        this.formData.listRemovedAttachmentIDs.push(id)
      }
    },

    async submit() {
      this.isFormLoading = true

      try {
        const data = {
          id: this.commentInfo.id,
          message: this.formData.content,
          listAtMentionIDs: this.formData.listAtMentionIDs,
          listFileUploadIDs: this.formData.listFileUploadIDs,
          listRemovedAttachmentIDs: this.formData.listRemovedAttachmentIDs,
        }

        await this.submitHandler(this.commentInfo.id, data)
      } catch (error) {
        this.$error.emit(error)
      } finally {
        this.isFormLoading = false
        this.disableEditMode()
      }
    },
  },
})
